import { connectedStore } from '../../store';
import actions from '../actions';

const show = (type, modalProps) => {
  const store = connectedStore.get();

  store.dispatch(actions.show(type, modalProps));
};

export default show;
